"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_from_layout_converter_1 = require("../base-from-layout.converter");
var immutable_1 = require("immutable");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var lodash_1 = require("lodash");
var DomainControllerCellFromFormLayoutConverter = /** @class */ (function (_super) {
    __extends(DomainControllerCellFromFormLayoutConverter, _super);
    function DomainControllerCellFromFormLayoutConverter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DomainControllerCellFromFormLayoutConverter.prototype.apply = function (controller) {
        var control = new idm_dynamic_layout_interpreter_1.ControlModel(controller.id, controller.fields, controller.meta.selector, controller.bindings, controller.actions, idm_dynamic_layout_interpreter_1.ControlPropertiesModel.fromJS(controller.id, controller.state), controller.meta, controller.isConfigurable);
        var titleModel = controller.title;
        if (lodash_1.isNil(titleModel) &&
            lodash_1.isNil(controller.singleFieldMultilingualDisplayName)) {
            titleModel = new idm_dynamic_layout_interpreter_1.TitleModel(controller.fieldMessageIdIfSingle(), 'msg');
        }
        else if (lodash_1.isNil(titleModel) &&
            !lodash_1.isNil(controller.singleFieldMultilingualDisplayName)) {
            titleModel = new idm_dynamic_layout_interpreter_1.TitleModel('', 'custom', controller.singleFieldMultilingualDisplayName);
        }
        return new idm_dynamic_layout_interpreter_1.CellModel(controller.id, new idm_dynamic_layout_interpreter_1.CellPropertiesModel(controller.id, 'transparent', {
            xs: controller.columnCount,
            s: controller.columnCount,
            m: controller.columnCount,
        }, undefined, immutable_1.Map(), controller.visibility), undefined, titleModel, control);
    };
    return DomainControllerCellFromFormLayoutConverter;
}(base_from_layout_converter_1.BaseFromLayoutConverter));
exports.DomainControllerCellFromFormLayoutConverter = DomainControllerCellFromFormLayoutConverter;
//# sourceMappingURL=domain-controller-cell-from-form-layout.converter.js.map